import React from "react";
import dateFormat from "dateformat";
import cx from "classnames";
import { NavLink } from "react-router-dom";
import _ from "lodash";
import { Col, Image, Row } from "react-bootstrap";

import NoIntegration from "src/legacy/images/integrations/nointegration.png";
import EmptyResult from "src/legacy/images/integrations/emptyresult.png";
import styles from "./styles.module.scss";
import Tooltip from "src/components/tooltip";

const PaperfliteIcon = '/images/Paperflite.png';
const DefaultAssetIcon = '/images/defaultIcons/default_asset.jpg';

class OpportunityRecommendedAssetsView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      integration: this.props.integration,
      recommended: this.props.recommended,
      shared: this.props.shared,
    };
  }

  componentDidMount() {
    this.props.fetchCRMEnabledIntegration();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.integration.item === null &&
      nextProps.integration.item !== null
    ) {
      this.props.searchOpportunityRecommendedAssets(this.props.id);
      this.props.searchOpportunitySharedAssets(this.props.id);
    }

    this.setState({
      integration: nextProps.integration,
      recommended: nextProps.recommended,
      shared: nextProps.shared,
    });
  }

  _integrationNotFound() {
    return (
      !this.state.integration.loading &&
      this.state.integration.item === null &&
      !_.isEmpty(this.state.integration.errors)
    );
  }

  _renderHighlights() {
    if (
      this.state.recommended &&
      this.state.recommended?.highlights?.length > 0
    ) {
      return this.state.recommended.highlights;
    }

    return [];
  }

  _returnRecommendedAssets() {
    if (this.state.recommended && this.state.recommended?.assets?.length > 0) {
      return this.state.recommended.assets;
    }

    return [];
  }

  _renderSharedAssets() {
    if (this.state.shared && !_.isEmpty(this.state.shared?.assets)) {
      return this.state.shared.assets;
    }

    return [];
  }

  _isLoading() {
    return (
      this.state.integration.loading ||
      (this.state.recommended.searching && this.state.shared.searching)
    );
  }

  _isLoaded() {
    return (
      !this.state.integration.loading &&
      !this.state.recommended.searching &&
      !this.state.shared.searching
    );
  }

  render() {
    return (
      <div className={styles.recommendations}>
        <PaperfliteLogoSection />

        {this._integrationNotFound() && <IntegrationNotFound />}

        {this._isLoading() && <LoadingMessage />}

        <ContentSection
          loaded={this._isLoaded()}
          highlights={this._renderHighlights()}
          recommended={this._returnRecommendedAssets()}
          recommendedSearching={this.state.recommended.searching}
          shared={this._renderSharedAssets()}
          sharedSearching={this.state.shared.searching}
        />
      </div>
    );
  }
}

class PaperfliteLogoSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className={styles.headerLogo}>
        <span className={styles.headerLogoText}> Powered by </span>
        <Image className={styles.headerLogo} src={PaperfliteIcon} />
      </div>
    );
  }
}

class LoadingMessage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return <div className={styles.loading}>Loading...</div>;
  }
}

class EmptyResultMessage extends React.Component {
  render() {
    return (
      <div className={styles.error}>
        <div className={styles.errorImageDiv}>
          <Image className={styles.errorImage} src={EmptyResult} />
        </div>
        <div className={styles.errorTitle}>No content found</div>

      </div>
    );
  }
}

class IntegrationNotFound extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className={styles.error}>
        <div className={styles.errorImageDiv}>
          <Image className={styles.errorImage} src={NoIntegration} />
        </div>
        <div className={styles.errorTitle}>
          You Integration has been deactivated in Paperflite
        </div>
      </div>
    );
  }
}

class ContentSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      highlights: [],
      selectedHighlights: [],
      recommended: [],
      recommendedSearching: false,
      shared: [],
      sharedSearching: false,
      loaded: false,
    };

    this._toggleHighlight = this._toggleHighlight.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      loaded: nextProps.loaded,
      highlights: nextProps.highlights,
      recommended: nextProps.recommended,
      recommendedSearching: nextProps.recommendedSearching,
      shared: nextProps.shared,
      sharedSearching: nextProps.sharedSearching,
    });
  }

  _toggleHighlight(highlight) {
    let selectedHighlights = this.state.selectedHighlights;

    let index = selectedHighlights.indexOf(highlight);

    if (index === -1) {
      selectedHighlights.push(highlight);
    } else {
      selectedHighlights.splice(index, 1);
    }

    this.setState({ selectedHighlights: selectedHighlights });
  }

  render() {
    return (
      <div className={styles.contentSection}>
        {(!_.isEmpty(this.state.recommended) ||
          !_.isEmpty(this.state.shared)) && (
          <RecommendationHeader
            highlights={this.state.highlights}
            selectedHighlights={this.state.selectedHighlights}
            toggleHighlight={this._toggleHighlight}
          />
        )}
        {this.state.loaded &&
          _.isEmpty(this.state.recommended) &&
          _.isEmpty(this.state.shared) && <EmptyResultMessage />}

        {!_.isEmpty(this.state.recommended) && (
          <RecommendedAssets
            highlights={this.state.highlights}
            selectedHighlights={this.state.selectedHighlights}
            assets={this.state.recommended}
          />
        )}

        {!this.state.recommendedSearching && !_.isEmpty(this.state.shared) && (
          <SharedAssets
            recommended={this.state.recommended}
            assets={this.state.shared}
          />
        )}
      </div>
    );
  }
}

class RecommendationHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      highlights: this.props.highlights,
      selectedHighlights: this.props.selectedHighlights,
    };

    this._isHighlightTag = this._isHighlightTag.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      highlights: nextProps.highlights,
      selectedHighlights: nextProps.selectedHighlights,
    });
  }

  _toggleHighlight(tag) {
    this.props.toggleHighlight(tag);
  }

  _isHighlightTag(tag) {
    if (!_.isEmpty(this.state.selectedHighlights)) {
      let index = this.state.selectedHighlights.indexOf(tag);
      if (index > -1) {
        return true;
      }
    }

    return false;
  }

  render() {
    return (
      <div className={styles.headerDiv}>
        <Row>
          <Col xs={7} sm={7} md={7} lg={7}>
            <div className={styles.headerTitle}>Filter by tags</div>
          </Col>
          <Col xs={5} sm={5} md={5} lg={5}></Col>
        </Row>
        <Row>
          <Col xs={7} sm={7} md={10} lg={10}>
            <div className={styles.headerHelpText}>
              Select or deselect the following tags to narrow down your content
              recommendations.
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            {this.state.highlights &&
              this.state.highlights.map((tag, index) => {
                return (
                  <div
                    className={cx(
                      styles.highlightTag,
                      this._isHighlightTag(tag) ? styles.highlightTagActive : ""
                    )}
                    key={index}
                    onClick={() => this._toggleHighlight(tag)}
                  >
                    <span className={styles.highlightTagText}>{tag}</span>
                  </div>
                );
              })}
          </Col>
        </Row>
      </div>
    );
  }
}

class RecommendedAssets extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      assets: this.props.assets,
      selectedHighlights: this.props.selectedHighlights,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      assets: nextProps.assets,
      selectedHighlights: nextProps.selectedHighlights,
    });
  }

  _renderRecommendedAssets() {
    var assetsCopy = [];
    if (this.state.assets && this.state.assets.length > 0) {
      assetsCopy = this.state.assets.slice(0);
    }

    var filtered = assetsCopy.filter((asset, index) => {
      if (_.isEmpty(this.state.selectedHighlights)) {
        return true;
      }

      if (_.isEmpty(asset.highlights)) {
        return false;
      }

      let highlightExists = false;
      for (const highlight of asset.highlights) {
        let highlightIndex = this.state.selectedHighlights.indexOf(highlight);

        if (highlightIndex > -1 && !highlightExists) {
          highlightExists = true;
        }
      }

      return highlightExists;
    });

    return filtered
      .slice(0, 3)
      .map((asset, index) => <RecommendedAsset key={asset.id} asset={asset} />);
  }

  render() {
    return (
      <div className={styles.recommendedAssetsDiv}>
        <div className={styles.title}>
          Recommended content for this opportunity
        </div>
        {this._renderRecommendedAssets()}
      </div>
    );
  }
}
class RecommendedAsset extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }
  _handleAssetClick(assetURL){
    const asset={
      url:assetURL
    }
    window.parent.postMessage(asset, "*");
  }

  render() {
    return (
      <div >
        {this.state.asset && (
          <div key={this.state.asset.id} className={styles.asset}>
            <div className={styles.assetThumbnail}>
              <Image
                onClick={()=>{
                    this._handleAssetClick(this.state.asset.id)}}
                className={styles.assetImage}
                src={
                  this.state.asset.icon
                    ? this.state.asset.icon.thumbnail
                    : DefaultAssetIcon
                }
              />
            </div>
            <div className={styles.assetDetail}>
              <AssetTitle asset={this.state.asset} />
              <AssetModified asset={this.state.asset} />
              <AssetMetrics asset={this.state.asset} />
            </div>
            <div className={styles.assetScore}>
              <MatchScore asset={this.state.asset} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

class SharedAssets extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      assets: this.props.assets,
      recommended: this.props.recommended,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      assets: nextProps.assets,
      recommended: nextProps.recommended,
    });
  }

  _renderSharedAssets() {
    var recommendedAssetIds = [];
    if (this.state.recommended && this.state.recommended.length > 0) {
      var recommended = this.state.recommended.slice(0);

      recommendedAssetIds = recommended.map((asset, index) => asset.id);
    }

    var assets = this.state.assets;
    if (recommendedAssetIds && recommendedAssetIds.length > 0) {
      var assetsCopy = this.state.assets.slice(0);

      assets = assetsCopy.filter(
        (asset, index) => recommendedAssetIds.indexOf(asset.id) === -1
      );
    }

    return assets
      .slice(0, 3)
      .map((asset, index) => <SharedAsset key={index} asset={asset} />);
  }

  render() {
    return (
      <div className={styles.similarAssetsDiv}>
        <div className={styles.title}>
          Content that help similar deals move forward
        </div>

        {this._renderSharedAssets()}
      </div>
    );
  }
}

class SharedAsset extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }

  render() {
    return (
      <div>
        {this.state.asset && (
          <div className={styles.asset}>
            <div className={styles.assetThumbnail}>
              <Image
                className={styles.assetImage}
                src={
                  this.state.asset.icon
                    ? this.state.asset.icon.thumbnail
                    : DefaultAssetIcon
                }
              />
            </div>
            <div className={styles.assetDetail}>
              <AssetTitle asset={this.state.asset} />
              <AssetModified asset={this.state.asset} />
              <AssetMetrics asset={this.state.asset} />
            </div>
            <div className={styles.assetScore}>
              <NoOfDeals asset={this.state.asset} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

class AssetTitle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      asset: nextProps.asset,
    });
  }

  _handleAssetClick(assetURL){    
    const asset={
      url:assetURL
    }
    window.parent.postMessage(asset, "*");
  }

  render() {
    return (
      <div title={this.state.asset.name}>
        <NavLink
          onClick={()=>{
            this._handleAssetClick(this.state.asset.id)}}
          className={styles.assetTitle}
        >
          {this.state.asset.name}
        </NavLink>
      </div>
    );
  }
}

class MatchScore extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ asset: nextProps.asset });
  }

  _formatScore(score) {
    if (score % 1 !== 0) {
      return score.toFixed(2);
    }

    return score;
  }

  getScoreRecommendationText(score) {
    if (score > 65) {
      return "This content is highly recommended for this stage of the deal";
    } else if (score > 30 && score <= 65) {
      return "This content is well recommended for this stage of the deal";
    }

    return "This content is recommended for this stage of the deal";
  }

  render() {
    return (
      <Tooltip content={this.getScoreRecommendationText(this.state.asset.score)} placement="top">
        <div className={styles.assetScoreText}>
          {this.state.asset.score !== 0 && (
            <span>
              {this.state.asset.score > 100
                ? 100
                : this._formatScore(this.state.asset.score)}
              % Match
            </span>
          )}
        </div>
      </Tooltip>
    );
  }
}

class NoOfDeals extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ asset: nextProps.asset });
  }

  render() {
    return (
      <div className={styles.assetScoreText}>
        {this.state.asset.deals !== 0 && (
          <span>
            {this.state.asset.deals > 1 ? (
              <span> {this.state.asset.deals} Deals </span>
            ) : (
              <span> {this.state.asset.deals} Deal </span>
            )}
          </span>
        )}
      </div>
    );
  }
}

class AssetModified extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ asset: nextProps.asset });
  }

  render() {
    return (
      <div className={styles.assetUpdatedBy}>
        Last Updated{" "}
        {dateFormat(_.get(this.state.asset, "contentModifiedDate"), "dd mmm yyyy")}
      </div>
    );
  }
}

class AssetMetrics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ asset: nextProps.asset });
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }
    return padding + number;
  }

  render() {
    const timeSpent = this.state.asset.avgTimeSpent || 0;
    let timeSpentValue = `~${this.padNumber(Math.round(timeSpent), 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    return (
      <div className={styles.metricsRow}>
        <span className={styles.metrics}>
          <i className={cx("paperflite-eye", styles.metricsIcon)} />
          <span className={styles.metricsText}> {this.state.asset.views} </span>
        </span>
        <span className={styles.metrics}>
          <i className={cx("paperflite-share", styles.metricsIcon)} />
          <span className={styles.metricsText}>
            {" "}
            {this.state.asset.shares}{" "}
          </span>
        </span>
        <span className={styles.metrics}>
          <i className={cx("paperflite-history", styles.metricsIcon)} />
          <span className={styles.metricsText}> {timeSpentValue} </span>
        </span>
      </div>
    );
  }
}

export default OpportunityRecommendedAssetsView;